export const lazy = (x, ... args) => 
    typeof x === "function" ?
    x(... args) :
    x;
